import { apiGet } from '../../api'

export const get_program_interactions = query => {
  return apiGet({
    endpoint: `programs/get_interactions?id=${query}`
  })
}
